import { render, staticRenderFns } from "./FAQStampSupport.vue?vue&type=template&id=11f134dc&scoped=true"
import script from "./FAQStampSupport.vue?vue&type=script&lang=js"
export * from "./FAQStampSupport.vue?vue&type=script&lang=js"
import style0 from "./FAQStampSupport.vue?vue&type=style&index=0&id=11f134dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f134dc",
  null
  
)

export default component.exports